import Image from "next/legacy/image";
import { useRouter } from "next/router";

import { useUserContext } from "@/features/auth/contexts/useUserContext";
import {
  AccessTypeEnum,
  ModelFragment,
  UserRoleEnum,
} from "@/generated/graphql-hooks";

export const EmptyModelPhotoList = ({
  accessType,
}: {
  accessType: AccessTypeEnum;
}) => {
  const { query, push } = useRouter();
  const { user } = useUserContext();

  return (
    <div className="mb-2 flex aspect-square flex-col items-center justify-center space-y-4">
      <div>
        <Image
          alt="emptyModelPhotos"
          src="/images/photo.png"
          layout="fixed"
          width={170}
          height={170}
          unoptimized
        />
      </div>
      <div className="flex flex-col items-center space-y-2">
        <div className="text-lg font-normal text-gray-700">沒有照片</div>
        {user?.role === UserRoleEnum.Model &&
          query?.modelId === (user?.roleData as ModelFragment)?.id &&
          accessType === AccessTypeEnum.Public && (
            <button
              className="text-base font-light text-gray-500"
              onClick={() => push("/kol/editPublicAlbum")}
            >
              請前往新增照片
            </button>
          )}
      </div>
    </div>
  );
};
